import React from 'react';

export default function SettingsPage() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Cài đặt Hệ thống</h2>
      <p>Trang cấu hình Webhook và tuỳ chọn AI...</p>
    </div>
  );
}
